import { v4 as uuidv4 } from "uuid";

const OrderMap = {};

export default class OrderModel {
  constructor(codigo, duracao) {
    this.codigo = codigo;
    this.duracao = duracao;
    this.uuid = uuidv4();
  }
  static novaSequenciada(codigo, inicio, fim, rowId) {
    const order = new OrderModel(codigo, inicio - fim);
    order.inicio = inicio;
    order.fim = fim;
    order.rowId = rowId;
    OrderModel.includeOnMap(order);
    return order;
  }

  static novoIntervalo(inicio, fim, rowId) {
    const order = new OrderModel("", inicio - fim);
    order.inicio = inicio;
    order.fim = fim;
    order.isInterval = true;
    order.rowId = rowId;
    return order;
  }

  static includeOnMap(order) {
    const key = order.codigo.slice(1);
    const charCode = OrderMap[key];
    let nextCharCode = charCode ? charCode + 1 : 65;
    OrderMap[key] = nextCharCode;
    order.codigo = String.fromCharCode(nextCharCode) + key;
  }

  static isSameOrder(cod1, cod2) {
    return cod1.slice(1) === cod2.slice(1);
  }

  static isFirstOrderOfType(codigo) {
    const key = codigo.slice(1);
    return OrderMap[key] === 65;
  }

  static hasNextOrder(codigo) {
    const val = codigo.charCodeAt(0);
    const key = codigo.slice(1);
    return OrderMap[key] !== val;
  }

  static lastCodeOfType(codigo) {
    const key = codigo.slice(1);
    return OrderMap[key];
  }

  setBackground(color) {
    this.background = color;
  }

  setMoveable(boolean) {
    this.isMoveable = boolean;
  }

  setRow(rowId) {
    this.rowId = rowId;
  }

  setTime(start, end) {
    this.inicio = start;
    this.fim = end;
  }
}
